

import { StoreContractUser } from '../../hooks/ContractUserStore'

import AutocompleteSearch from '@front-ends/common/src/components/app/AutocompleteSearch';
import { ContractUser } from '../../models/ContractUserTypes';
import { Box, DialogActions, Typography } from '@mui/material';
import { useState } from "react";
import RequestAccess from '../Access/RequestAccess';


export default function ContractUserSearch({ currentProjectId, currentUserName, currentServiceId }: any) {

    const { searchUser, responseUser } = StoreContractUser();
    const [selectedUsers, setSelectedUsers] = useState<ContractUser[]>([]);

    function addUsers(v: ContractUser[]) {
        setSelectedUsers(v);       
    }

    const projectUsers = selectedUsers.map(u => u?.mail);
    const isButtonDisable = selectedUsers.length === 0;

    return (
        <Box>
            <Typography gutterBottom>
            <AutocompleteSearch 
                optionsLabel={"mail"}
                optionsName={"displayName"}
                keyLabel={"id"}
                searchStore={searchUser}
                responseStore={responseUser}
                addResultFunction={addUsers}
                displayLabel={""}
                customSearchItems={null}
                multipleResponse={true}
            />
            </Typography>
            <DialogActions>
            <RequestAccess users={projectUsers} currentProjectId={currentProjectId} currentUserName={currentUserName} currentServiceId={currentServiceId} isButtonDisable={isButtonDisable} />
            </DialogActions>
        </Box>

    );
}